import { type PanelMember } from '../GSPanelDetail';
import { type FundingPanel } from '../../../../Nomination/components';
import { type SelectOption } from '../../../../../components';
import { type PanelLockedFilter } from '../../../GSAssessment';

export enum PANEL_STATUS {
  PREPARED = 'PREPARED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  DELETED = 'DELETED',
}

export const panelStatusLabel: Record<PANEL_STATUS, string> = {
  [PANEL_STATUS.PREPARED]: 'Prepared',
  [PANEL_STATUS.IN_PROGRESS]: 'In progress',
  [PANEL_STATUS.COMPLETED]: 'Completed',
  [PANEL_STATUS.DELETED]: 'Deleted',
};

export type ApplicationsInPanel = {
  applicationId: string;
  reviewers: PanelApplicationReviewer[];
  classification: FundingPanel;
  items: PanelApplicationItem[];
};

export type PanelApplicationReviewer = {
  netId: string;
  comment?: string;
  declaration?: boolean;
};
export type GSPaginatedPanelList = {
  data: PanelFormData[];
  totalPage: number;
  count: number;
};
export type PanelApplicationItem = {
  column: string;
  content: string;
};

export type getPanelFormData = {
  getPanel: PanelFormData;
  refetch: () => void;
};

export type AdvancedUserInfoFilter = {
  netId?: string;
  netIds?: string[];
};
export type PanelFormData = {
  panelNo?: string;
  _id?: string;
  fundingSource: string;
  entryYear: string;
  title: string;
  panelType: FundingPanel | '';
  endDate: string | null; // remove start date, end date stands for meeting
  panelChair: string;
  tagOptions: string[];
  resultOptions: SelectOption[];
  panelMember: PanelMember[];
  status: PANEL_STATUS;
  lockFilter?: PanelLockedFilter;
};

export type UpdatePanelInput = {
  _id: string;
  endDate: string;
  fundingSource: string;
  panelChair: string;
  panelRound: number;
  panelType: string;
  resultOptions: string[];
  startDate: string;
  status: string;
  tagOptions: string[];
  title: string;
  totalRound: number;
};

export type PanelBaseFilter = {
  _id: StringFilter;
  panelNo: StringFilter;
};

export type StringFilter = {
  eq: string;
  ne: string;
  gt: string;
  gte: string;
  lt: string;
  lte: string;
  in: string[];
  nin: string[];
  regex: string;
  options: string;
};
